<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>系统管理->字典管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div style="height:50px; margin:5px 16px 0 0px;">
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-select v-model="form.deptId" placeholder="请选择学校">
                            <el-option
                                v-for="item in depts"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div style="display: inline-block; height:40px;">
                    <div style="width:160px;">
                        <el-input v-model="form.name" placeholder="KEY"></el-input>
                    </div>
                </div>
                &nbsp;
                <div style="display: inline-block; height:40px;">
                    <el-button type="primary" icon="search" @click="getData()">查询</el-button>
                </div>
                <div style="display: inline-block; height:40px;float: right;">
                    <el-button type="primary"  class="handle-del mr10" icon="el-icon-plus" @click="setAdd('')">新增</el-button>
                    <el-button type="danger"  v-if="currUserId == 1" @click="setCopy()">复制</el-button>
                </div>
            </div>

             <el-table
                :data="data"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                style="width: 100%;margin-bottom: 20px;"
                row-key="id"
                border
                :tree-props="{children: 'children'}">
                <el-table-column type="selection" width="55"  :selectable="selectable"></el-table-column>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="text" label="KEY" width="150">
                </el-table-column>
                <el-table-column prop="attributes.value" label="值" width="360" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="attributes.remark" label="备注" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column fixed="right" label="操作"  width="110">
                    <template slot-scope="scope">
                         <el-button  @click.native.prevent="setAdd(scope.row.id)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">新增</span>
                        </el-button>
                        <el-button  @click.native.prevent="setUpdate(scope.row)"
                            type="text"
                            size="small">
                            <span style="color: #387EE8;">修改</span>
                        </el-button>
                        <el-button style="color: red" @click.native.prevent="del(scope.row)"
                            type="text"
                            size="small">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新增/修改弹出框 -->
        <div v-if="addVisible">
            <add ref="add"></add>
        </div>
        <div v-if="updateVisible">
            <update ref="update"></update>
        </div>
        <div v-if="setCopyVisible">
            <setCopy ref="setCopy"></setCopy>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import add from './Add.vue';
    import update from './Update.vue';
    import setCopy from './SetCopy.vue';

    export default {
        name:"Dict",
        data(){
            return{
                loading:false,
                addVisible:false,
                updateVisible:false,
                setCopyVisible:false,
                form:{
                    name:"",
                    deptId:""
                },
                depts:[],
                data:[],
                currUserId:""
            }
        },
        components: {
            add,update,setCopy
        },
        created:function () {
            this.getDeptData();
            //获取当前登录用户，然后当前用户不能编辑自己也不能删除自己
            this.currUserId=JSON.parse(sessionStorage.getItem('userinfo')).id;
        },
        methods:{
            indexMethod(index) {
                return index+1;
            },
            getDeptData(){
                this.loading=true;
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                        if(this.depts.length>0){
                           this.form.deptId=this.depts[0].id;
                        }
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            getData(){
                let url  = this.dictUrl;
                let data = {
                    name:this.form.name,
                    deptId:this.form.deptId
                };
                
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                       this.data = res.data.dicts;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{

                });
            },
            selectable(row){
                if(row.id == 1){
                    return false;
                }
                else{
                    return true;
                }
            },
            //新增界面
            setAdd(id){
                this.addVisible=true;
                this.$nextTick(() => {
                    this.$refs['add'].init(1,this.form.deptId,id);
                })
            },
            //修改界面
            setUpdate(data){
                this.updateVisible=true;
                this.$nextTick(() => {
                    this.$refs['update'].init(2,data);
                })
            },
            setCopy(){ // 复制对象
                this.setCopyVisible=true;
                this.$nextTick(() => {
                    this.$refs['setCopy'].init(this.form.deptId);
                })
            },
            //删除
            del(data){
                this.form.id = data.id;
                this.$commonFn.showConfirm(this.delSuccess);
            },
            delSuccess(){
                let url = this.dictDelUrl;
                let data = {
                    id:this.form.id
                };
                this.apiPost(url,data).then((res)=>{
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/sys/dict/Dict.vue